module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "om-page-heading"
  }, [_c('label', {
    attrs: {
      "for": "search"
    }
  }, [_vm._v(_vm._s(_vm.$tr('Lista zamówień', 'OrderList')))])]), _vm._v(" "), _c('form', {
    staticClass: "om-search flex sb",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchAction.apply(null, arguments)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchValue),
      expression: "searchValue"
    }],
    staticClass: "om-search__input fg-20",
    attrs: {
      "id": "search",
      "placeholder": _vm.$tr('Imię i nazwisko lub numer zamówienia', 'OrderList'),
      "title": _vm.$tr('Imię i nazwisko lub numer zamówienia', 'OrderList')
    },
    domProps: {
      "value": (_vm.searchValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "om-btn om-search__submit",
    attrs: {
      "type": "submit",
      "placeholder": _vm.$tr('', 'OrderList')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.searchAction.apply(null, arguments)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$tr('Szukaj', 'OrderList')) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading flex sb"
  }, [(_vm.pageContent instanceof Array && _vm.pageContent.length) ? _c('div', {
    staticClass: "flex wrap"
  }, [_c('div', {
    staticClass: "om-list-heading__label om-list-heading__label--bright"
  }, [_vm._v(_vm._s(_vm.$tr('Wyniki wyszukiwania:', 'OrderList')))]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading__label"
  }, [_vm._v(_vm._s(_vm.searchValue))]), _vm._v(" "), _c('div', {
    staticClass: "om-list-heading__label om-list-heading__label--num"
  }, [_vm._v("(" + _vm._s(_vm.searchResultsCount) + ")")])]) : _vm._e()]), _vm._v(" "), (!_vm.noContent) ? _c('table', {
    staticClass: "om-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.columns.reference))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.date))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.firstname))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.status))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.columns.details))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.pageContent), function(item, k) {
    return _c('tr', {
      key: k
    }, [_c('td', {
      staticClass: "reference"
    }, [_vm._v(_vm._s(item.reference))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.$moment(item.date).format('DD.MM.YYYY')))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "font-normal",
      domProps: {
        "innerHTML": _vm._s(_vm.highlight(item.firstname + ' ' + item.lastname, _vm.search))
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "status",
      style: ({
        color: item.statusColor
      })
    }, [_vm._v(_vm._s(item.status))]), _vm._v(" "), _c('td', {
      staticClass: "more"
    }, [_c('router-link', {
      attrs: {
        "to": '/admin/order-list/' + item.reference
      }
    }, [_c('i', {
      staticClass: "om-ico-zoom",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1)])
  }), 0)]) : (typeof _vm.request.params.query !== 'undefined' && _vm.request.params.query != '') ? _c('div', {
    staticClass: "om-information"
  }, [_vm._v("\n    " + _vm._s(_vm.$tr('Brak wyników. Spróbuj zmienić parametry wyszukiwania.', 'OrderList')) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "om-list-footer flex sb"
  }, [_c('div'), _vm._v(" "), _c('paginator', {
    attrs: {
      "items-per-page": _vm.currentPerPage,
      "passive-mode": _vm.paginatorPassive,
      "request": _vm.request,
      "update-force": _vm.requestUpdateForce,
      "active": _vm.activeListing
    },
    on: {
      "change": _vm.updatePageContent,
      "results-count": _vm.updateResultsCount
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fa872e76","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/OrderList.vue
// module id = 288
// module chunks = 1